<a
  mat-list-item
  (click)="onItemSelected(item)"
  [ngClass]="{
    active: item.route ? router.isActive(item.route, true) : false,
    expanded: expanded
  }"
  class="menu-list-item"
>
  <div fxFlex="row" fxFlex="100" fxLayoutAlign="center center">
    <span
      [ngClass]="{ child: isChild, subChild: depth > 1 }"
      fxFlex="100"
      fxFlex="row"
      fxLayoutAlign="start center"
    >
      <div>{{ item.displayName }}</div>
    </span>
    <span *ngIf="item.children && item.children.length">
      <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
        expand_more
      </mat-icon>
    </span>
  </div>
</a>
<div *ngIf="expanded">
  <app-nav-menu-list-item
    *ngFor="let child of item.children"
    [item]="child"
    [depth]="depth + 1"
    [isChild]="true"
  >
  </app-nav-menu-list-item>
</div>
